export default __webpack_public_path__ + "static/media/staking.2fcda179.png";